export const CONFIG = {
  "syllabus": "https://docs.google.com/document/d/e/2PACX-1vRm9dEGZhnX1RTciZzinc6_0MReyQmzHS3CoKjeyEXa_i_7g0W-wAsMnGze5NcOKR_NphMDFVx2sIOW/pub?embedded=true",
  "projectSubmission": "https://docs.google.com/presentation/d/12ykNb818jhrAkVzhmlKzbOeyO4zm_IlwEeLTfzTFG4o/edit?usp=sharing",
  "TAs": [
    {
      "name": "Case Wright",
      "position": "Head UTA",
      "email": "wrigh404@purdue.edu"
    },
    {
      "name": "Thomas Simons",
      "position": "Head UTA",
      "email": "simonst@purdue.edu"
    },
    {
      "name": "Jerry Hsu",
      "position": "UTA",
      "email": "hsu147@purdue.edu"
    },
    {
      "name": "Christopher Sculley",
      "position": "UTA",
      "email": "csculley@purdue.edu"
    },
    {
      "name": "Hunter Moore",
      "position": "UTA",
      "email": "moore586@purdue.edu"
    },
    {
      "name": "Aeson Omar Akhras",
      "position": "UTA",
      "email": "aakhras@purdue.edu"
    },
    {
      "name": "Zhenmu Gong",
      "position": "UTA",
      "email": "gong133@purdue.edu"
    }
  ],
  "labSessions": [
    {
      "day": "W",
      "time": "3:30-5:20pm",
      "location": "LWSN B131",
      "TAs": "Case, Thomas, Hunter, Aeson, Jerry"
    },
    {
      "day": "R",
      "time": "1:30-3:20pm",
      "location": "LWSN B131",
      "TAs": "Case, Thomas, Hunter, Chris, Gong"
    }
  ],
  "labs": [
    {
      "name": "Assignment 1",
      "route": "/labs/1",
      "url": "https://docs.google.com/document/d/e/2PACX-1vRfz_WU4kvmfjQEuJwqXZcsrswBK5DZ2DcCcXxMf3n-wuQ-biW1IX1Qb8uTk8h6s9U996ws7htiHf1l/pub?embedded=true"
    },
    {
      "name": "Assignment 2",
      "route": "/labs/2",
      "url": "https://docs.google.com/document/d/e/2PACX-1vTAkl8OnuPzM7uAm3Oa1KikP52SxIwDvSuntgU7_wFk-753RgUpYk0lccWrLM-fUXNJRRnaD3sLjuax/pub?embedded=true"
    },
    {
      "name": "Assignment 3",
      "route": "/labs/3",
      "url": "https://docs.google.com/document/d/e/2PACX-1vQMPWFVIVo5qxmIZmDB8l8MDT-v7X4_xr57KQonZ5VlxhDWipp7nYIoixTFGWaHtRMb7ti_cXfvpc4W/pub?embedded=true"
    },
    {
      "name": "Assignment 4",
      "route": "/labs/3",
      "url": "https://docs.google.com/document/d/e/2PACX-1vTTW-kUh9DrdGg3p6G7TA13mCJgn4RoVggoekSCopxFz5mQV_AZ6aY10AZOpQDmsZNE2T1sFQEsaA-R/pub?embedded=true"
    },
    {
      "name": "Project",
      "route": "/project",
      "url": "https://docs.google.com/document/d/e/2PACX-1vSC8qL4XygvnGYl-dn1_zlurkMPdR03VZf8Vt6fxe756-M6GPGl_Ntku7gEyPW4G-xkRC-la88cBC3A/pub?embedded=true"
    }
  ],
  "slides": [
    {
      "name": "Course Introduction",
      "link": "https://docs.google.com/presentation/d/e/2PACX-1vTaDq1Js7vTOuDG-mzLz0D7mHiNOPZXKZkg1Xzn8ok_CfhM-hdTAQnv9fWdBduHim81ktr0h20VOfyx/pub?start=false&loop=false&delayms=3000"
    },
    {
      "name": "Intro to VR",
      "link": "https://docs.google.com/presentation/d/e/2PACX-1vQAHjVrc7qKQ-YUVTb2BToTG8_wv7xdGY6B3nqP7Fhmov7X0m4nP7ux0x-asFShaRJAuAjP0CorqZdD/pub?start=false&loop=false&delayms=3000"
    },
    {
      "name": "Intro to Unity",
      "link": "https://docs.google.com/presentation/d/e/2PACX-1vSb7wLMTRGjEXU-5y86QxszVwi8CiMUPyCO9htiyUuzYbD6HtQ9aOsaa5EkLnp_Xm8-z8FQPLV9WQiL/pub?start=false&loop=false&delayms=3000"
    },
    {
      "name": "Unity",
      "link": "https://docs.google.com/presentation/d/e/2PACX-1vQcQemx02_9iWs4XCBPn9EBscW2_29WhfbqcXPOHBt1E0Fg5JmXO74Av99137WfdbgPLUcwXP9BjNo2/pub?start=false&loop=false&delayms=3000"
    },
    {
      "name": "UI in Unity",
      "link": "https://docs.google.com/presentation/d/e/2PACX-1vQyPpZEjKXQaKgCrxlfcfRN8fMmy48FoOGWt5T8zxs9G-mNMO9aQcmBYCyJJa1320GpQbGmAYvavUAU/pub?start=false&loop=false&delayms=3000"
    },
    {
      "name": "Motion Sickness",
      "link": "https://docs.google.com/presentation/d/e/2PACX-1vRv3GkSZYknl6pM6xrB1vU1slqfW56mvyuE5R9QQv1zUxtAuZBOkfbzARMUIDQqFW_xZLqIRHXRyYWx/pub?start=false&loop=false&delayms=3000"
    },
    {
      "name": "Audio & Animations",
      "link": "https://docs.google.com/presentation/d/1SSPKiNVb1jKwUbznwz0kadozsSrma1M2F5PHujuOE9Q/edit?usp=sharing"
    },
    {
      "name": "Particle System and NavMesh",
      "link": "https://docs.google.com/presentation/d/1IuFvkt3WW8AL0to07iSHFlpfSJnPSs84LGv5bTD1cns/edit?usp=sharing"
    }
  ],
  "pastProjects": [
    {
      "semester": "Spring 2018 Midterm",
      "link": "https://docs.google.com/document/d/e/2PACX-1vRXgjr3sUND_SVl67nml03OzD_cJeju1Fj4Q6yFbK_jwg-PzSeqXtDCq62nLdLGOG3290vIyldGc0aD/pub"
    },
    {
      "semester": "Fall 2018 Midterm",
      "link": "https://docs.google.com/document/d/e/2PACX-1vQlI8iVcUgMB8TGBP-seeAI6QGDDVmasYbfc_mJX38TUKXb0S5fa7K8fmsCC1KBPRkKw9njWs4dCpJS/pub"
    },
    {
      "semester": "Spring 2018 Final",
      "link": "https://docs.google.com/document/d/e/2PACX-1vQixVNBRPb-VmDw7m60TLwjGoeHa3drx1P0YZ5rs_oiJEnCnq_6DWeGoEGY6VxJby43UIlbEMuqw7uj/pub"
    },
    {
      "semester": "Fall 2018 Final",
      "link": "https://docs.google.com/document/d/e/2PACX-1vRCoaJW_3Dfp8XZD48vO3kMhEeVZ9TL9EFERQpMhwiKgEhPgNel3wtBnaV5ap40o-FeAq9lOKO-snb_/pub"
    }
  ]
}